"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var InvalidParametersComponent = /** @class */ (function () {
    function InvalidParametersComponent() {
    }
    InvalidParametersComponent.prototype.ngOnInit = function () {
    };
    return InvalidParametersComponent;
}());
exports.InvalidParametersComponent = InvalidParametersComponent;
